import React from 'react'
import { returnOrdersData } from '@/features/profile-page/ReturnOrders/ordersData'
import CardReturnOrder from '@/entities/profile-page/returnOrders/CardReturnOrder'
import CardHistoryReturnOrder from '@/entities/profile-page/returnOrders/CardHistoryReturnOrder'
import { useInView } from 'react-intersection-observer'

const navigation = ['Возврат товаров', 'История возвратов']
export const ReturnOrders = () => {
    const [category, setCategory] = React.useState(navigation[0])
    const { ref, inView } = useInView({
        threshold: 0,
        triggerOnce: true,
    })
    return (
        <div
            ref={ref}
            className={`ReturnOrders ${
                inView && 'animate__animated animate__zoomInRight'
            }`}
        >
            <div className={'navigation'}>
                {navigation.map((item) => (
                    <button
                        key={item}
                        onClick={() => setCategory(item)}
                        disabled={category === item}
                    >
                        {item}
                    </button>
                ))}
            </div>
            <div className={'return-orders-content'}>
                {category === navigation[0] &&
                    returnOrdersData.map((orderData) => (
                        <CardReturnOrder
                            key={orderData.orderNumber}
                            order={orderData}
                        />
                    ))}
                {category === navigation[1] &&
                    returnOrdersData.map((orderData) => (
                        <CardHistoryReturnOrder
                            key={orderData.orderNumber}
                            order={orderData}
                        />
                    ))}
            </div>
        </div>
    )
}
